<template>
  <div>
    <Header />
    <main v-if="isCheckingSeasonGoal" class="main">
      <section class="section">
        <div class="season-start-loader">
          <span class="season-start-loader__spinner"></span>
        </div>
      </section>
    </main>
    <SeasonComponent v-else />
    <Footer />
  </div>
</template>

<script>
import SeasonComponent from '@/components/Season/index.vue'
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'SeasonStart',
  components: {
    SeasonComponent,
    Header,
    Footer
  },
  data() {
    return {
      isCheckingSeasonGoal: true,
    }
  },
  async mounted() {
    await this.$store.dispatch('season/getSeasonProgress')
    this.isCheckingSeasonGoal = false
  },
  destroyed() {
    this.$store.dispatch('season/clear')
  },
}
</script>

<style>
.season-start-loader {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 220px);
}

.season-start-loader__spinner {
  width: 48px;
  height: 48px;
  border: 5px solid #012653;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: season-start-loader-rotation 1s linear infinite;
}

@keyframes season-start-loader-rotation {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
